import { Checkbox, FormControlLabel, FormGroup, Radio } from "@mui/material";
import { FORMATTER } from "../../../services";

const AddonsSelectCheckbox = ({
  addon,
  addongroup,
  handleSelectionClick,
  isSelected,
}) => {
  const buttonConfig = {
    useRadioButtons:
      addongroup && addongroup.addons_data?.optiontype === "singlerequired",
    showYesOnBtn:
      addongroup && addongroup.addons_data?.optiontype === "multiselectyes",
    showNoOnBtn:
      addongroup && addongroup.addons_data?.optiontype === "multiselectno",
  };

  const renderLabel = (row) => {
    let text = row.option;
    if (buttonConfig.showYesOnBtn) {
      text = row.option + " - Ja takk";
    } else if (buttonConfig.showNoOnBtn) {
      text = row.option + " - Nei takk";
    }

    return (
      <>
        {text}&nbsp;({FORMATTER.formatCurrent(row.price_out)})
      </>
    );
  };

  return (
    <FormGroup>
      {(addon || []).map((row, idx) => (
        <FormControlLabel
          key={"addonoption_" + idx}
          sx={{ padding: 0.5 }}
          control={
            buttonConfig.useRadioButtons ? (
              <Radio
                sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                color="secondary"
              />
            ) : (
              <Checkbox
                sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                color="secondary"
              />
            )
          }
          onChange={(event) => handleSelectionClick(row)}
          checked={isSelected(row)}
          label={renderLabel(row)}
        />
      ))}
    </FormGroup>
  );
};

export default AddonsSelectCheckbox;
